import { useRef } from "react";
import { ImageAsset } from "../../sanity/lib/types/imageAsset";
import { ImageElement } from "./Image";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";

gsap.registerPlugin(useGSAP);

export const ImageRepeater = ({
    images,
    width = 2560,
    className,
    imageClassName,
    loading,
    style,
}: {
    images: ImageAsset[];
    width?: number;
    imageClassName?: string;
    className?: string;
    loading?: "lazy" | "eager";
    style?: React.CSSProperties;
}) => {
    if (!images || images.length === 0) {
        return;
    }

    const divContainer = useRef<HTMLDivElement>(null);

    useGSAP(
        () => {
            const images = gsap.utils.toArray<HTMLElement>(`img`);

            if (images.length <= 1) return;

            // alle Bilder erstmal unsichtbar setzen
            gsap.set(images, { autoAlpha: 0 });
            gsap.set(images[0], { autoAlpha: 1 });

            const tl = gsap.timeline({
                repeat: -1,
            });

            images.forEach((img) => {
                tl.to(img, { autoAlpha: 1, duration: 0 }).to(
                    img,
                    { autoAlpha: 0, duration: 0 },
                    "+=1",
                ); // nach kurzer Zeit wieder ausblenden
            });
        },
        { scope: divContainer },
    );

    return (
        <div ref={divContainer} className={`image-repeater ${className}`}>
            {images.map(
                (image, imgIndex) =>
                    image.image && (
                        <ImageElement
                            className={`${imageClassName} w-full h-auto object-cover ${imgIndex === 0 ? "relative" : "absolute top-0 left-0 w-full h-full"}`}
                            width={width}
                            key={imgIndex}
                            loading={loading}
                            style={style}
                            alt={image.alt || ""}
                            src={image.image}
                        />
                    ),
            )}
        </div>
    );
};
